import { ConfirmDialog } from '@gogame/components';
import { useDateFormat } from '@gogame/intl-ts';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { removeMainBudgetPlanning } from 'scenes/MainBudgetPlanning/sources/mainBudgetPlanning';

import { remove } from '../queryKeyFactory';

export const useDeleteMainBudgetPlanning = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const deleteMutation = useMutation(remove(), removeMainBudgetPlanning, {
    successMessage: () => `Period was deleted`,
  });

  const dateFormat = useDateFormat({ template: 'MONTH' });

  const handleAction = async ({ id, period }) => {
    await showModal({
      title: `Delete Period?`,
      confirmActionLabel: 'Delete',
      bodyText: dateFormat(period[0]),
    });
    await deleteMutation.mutateAsync({ id });
  };

  return [handleAction, deleteMutation];
};
